<script setup lang="ts">
import { useFormErrors, useFormValues } from 'vee-validate'
import { useElementalForm } from './context'
import IconButton from '~~/src/components/IconButton/index.vue'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

defineOptions({
  name: 'FormDebugger',
})

const { elementalType, formId, elemental } = useElementalForm()
const { value: formData } = useFormValues()
const errors = useFormErrors()

const formString = computed(() => {
  try {
    return JSON.stringify(unref(formData), null, 2)
  }
  catch (error) {
    return JSON.stringify({ error: 'Invalid Json' }, null, 2)
  }
},
)
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <IconButton class="w-9 h-9 basis-1" title="Toggle Debug Menu" icon="i-material-symbols:bug-report-outline-rounded" icon-class="w-6 h-6" />
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-56">
      <DropdownMenuLabel class="text-xs">
        Id: {{ elemental?.id ?? 'New elemental' }}
      </DropdownMenuLabel>
      <DropdownMenuLabel>
        <div class="bg-white bg-softBlack/60 text-white backdrop-blur-3 p-2 rounded-lg mt-2 max-h-[40svh] max-w-[70svw] overflow-y-auto ">
          <p>
            {{ elementalType?.name.toUpperCase() }} Form Debugger {{ formId }}
          </p>
          <details>
            <summary>Errors</summary>
            <pre>{{ JSON.stringify(errors, null, 2) }}</pre>
          </details>
          <details>
            <summary>Values</summary>
            <pre>{{ formString }}</pre>
          </details>
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
    </DropdownMenuContent>
  </DropdownMenu>
</template>
